import {AppConfigKeyVo} from '../common/shared/api/nicolas/vo/enums/AppConfigKeyVo.enum';

export function getAppConfigRequestKeys(keys: AppConfigKeyVo[]): string {
  return keys.join(',');
}
